<template>
	<section class="section" v-if="product !== null && !loading">
		<breadcrumb :crumbs="crumbs"></breadcrumb>
		<div class="container item-view">
			<div class="columns item-view is-multiline">
				<div class="column is-one-third has-text-centered">
					<img :src="BASE_URL + '/images/' + product.imageId + '/original'" v-if="product.imageId !== null">
					<span class="is-size-5" v-else>No Image Available</span>
				</div>
				<div class="column product-content is-one-third">
					<div class="content">
						<h3>{{product.name}}</h3>
						<h4><span v-if="isCustom">Starting at </span>$ {{ (product.price / 100).toFixed(2) }}</h4>
    <span style="font-size: 12px;">*Pricing includes delivery and taxes</span>
					</div>
					<div class="fr-view content" v-html="product.content"></div>
					<button type="button" class="button" @click="addToCart">Add to Cart</button>
				</div>
			</div>
		</div>
	</section>
	<loader v-else></loader>
</template>

<script>
import Loader from './Loader';
import Breadcrumb from './Breadcrumb.vue';
import { BASE_URL } from '../http';
import PageViewVue from './PageView.vue';

export default {
  components: { Loader, Breadcrumb },
  name: 'product-view',

  created() {
    this.load();
  },

  methods: {
    load() {
      this.$store.commit('progress/start');

      this.$store
        .dispatch('product/load', this.$route.params.product_name)
        .then(() => this.$store.commit('progress/stop'));
    },

    addToCart() {
      this.$store.dispatch('cart/add', { id: this.product.id, quantity: 1 }).then(() => {
        this.$router.push('/cart');
      });
    },
  },

  computed: {
    crumbs() {
      if (this.product !== undefined && this.product !== null) {
        return [
          { text: this.$route.params.ecat.toUpperCase(), l: `/${this.$route.params.ecat}` },
          {
            text: this.$route.params.category.toUpperCase().replace(new RegExp('-', 'g'), ' '),

            l: `/shop/${this.$route.params.ecat}/${this.$route.params.category}`,
          },
          {
            text: this.product.name.toUpperCase(),
          },
        ];
      } else return [];
    },
    product() {
      return this.$store.state.product.product;
    },

    loading() {
      return this.$store.state.product.loading;
    },

    BASE_URL() {
      return BASE_URL;
    },

    isCustom() {
      return this.product.name.startsWith("Custom")
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ProductView.vue